// extracted by mini-css-extract-plugin
export default {"pageTitle":"EnrollmentsDashboard_pageTitle__KtiSu","contentBody":"EnrollmentsDashboard_contentBody__Csc7v"};